var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 576 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M540.596,465.569c2.261,4.474 3.44,9.418 3.44,14.432c-0,17.554 -14.445,31.999 -32,31.999c-0.026,0 -0.053,-0 -0.079,-0l-447.993,-0c-17.576,-0.07 -32,-14.551 -32,-32.127c0,-4.964 1.151,-9.86 3.36,-14.304l223.997,-449.273c10.88,-21.728 46.431,-21.728 57.279,-0l223.996,449.273Zm-11.007,5.488l-223.994,-449.268c-3.296,-6.6 -10.572,-9.489 -17.623,-9.489c-7.056,0 -14.341,2.894 -17.651,9.499l-223.984,449.248c-1.363,2.742 -2.073,5.763 -2.073,8.826c0,10.841 8.892,19.774 19.731,19.827l447.962,-0c0.01,-0 0.063,0 0.079,0c10.807,0 19.7,-8.893 19.7,-19.699c-0,-3.087 -0.726,-6.13 -2.118,-8.885c-0.01,-0.02 -0.02,-0.039 -0.029,-0.059Zm-285.888,-157.247l-0.04,-89.806c-0,-24.302 19.997,-44.299 44.299,-44.299c24.302,-0 44.3,19.997 44.3,44.294l0.039,89.806c0,24.302 -19.997,44.3 -44.299,44.3c-24.3,-0 -44.297,-19.995 -44.299,-44.295Zm12.3,-0.005c-0,17.554 14.445,32 31.999,32c17.554,-0 31.999,-14.446 31.999,-32l-0.039,-89.801c-0,-17.554 -14.445,-31.999 -32,-31.999c-17.554,-0 -31.999,14.445 -31.999,31.999l0.04,89.801Zm-12.34,102.196c-0,-24.302 19.997,-44.299 44.299,-44.299c24.302,-0 44.3,19.997 44.3,44.299c-0,24.302 -19.998,44.3 -44.3,44.3c-24.302,-0 -44.299,-19.998 -44.299,-44.3Zm12.3,0c-0,17.555 14.445,32 31.999,32c17.555,-0 32,-14.445 32,-32c-0,-17.554 -14.445,-31.999 -32,-31.999c-17.554,-0 -31.999,14.445 -31.999,31.999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/risk.ed659ab2a5b10245355b992426bde205.svg";
export { ForwardRef as ReactComponent };